/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import YoutubePage from '../../../pages/InsigthPage/Youtube/YoutubePage'
import { getListTags, createList, getFeelings } from '../../../services/youtubeService'
import filterArray from '../../../utils/filterArray'
import useLocalStorage from '../../../utils/hooks/useLocalStorage'
import { INSIDE_DETAIL } from '../../../routes/paths'

const YoutubeContainer = () => {
  const [searchList, setSearchList] = useState('')
  const [list, setList] = useState({})
  const [creatList, setCreateList] = useState({})
  const [loading, setLoading] = useState(false)
  const [openAddToList, setOpenAddToList] = useState(false)
  const [update, setUpdate] = useState(false)
  const [, setItemToList] = useLocalStorage('itemToList', false)

  const history = useHistory()

  const handleSearchList = event => {
    setSearchList(event.target.value)
  }

  /*= =======================================================================
 Select video List
======================================================================== */
  const handleSelectList = value => {
    setItemToList(value)
    history.push(INSIDE_DETAIL)
  }
  /*= =======================================================================
 onChange input Search
======================================================================== */
  const onChange = (event, type) => {
    setCreateList({ ...creatList, [type]: event.target.value })
  }

  /*= =======================================================================
  Get All Feelings
======================================================================== */
  const handleFeelings = async item => {
    let result = []
    let sum = 0
    let res = 0
    let neutro = 0
    try {
      if (item?.analisis) {
        const analisisId = item?.analisis[item?.analisis?.length - 1]?.analisisId
        const feelings = await getFeelings(item._id, analisisId)
        if (Array.isArray(feelings)) {
          result = feelings
            .map(feelin =>
              feelin?.sentences.map(({ sentiment }) => {
                const { score } = sentiment
                return {
                  _id: item._id,
                  score,
                  tMagnitude: feelin.sentiment.magnitude,
                  tScore: feelin.sentiment.score,
                }
              })
            )
            .reduce((acc, current) => {
              current.forEach(value => {
                if (value.score > 0) {
                  sum += 1
                }
                if (value.score === 0) {
                  neutro += 1
                }
                if (value.score < 0) {
                  res += 1
                }
              })
              return {
                _id: item._id,
                calculo: {
                  sum,
                  res,
                  neutro,
                  tMagnitude: current[0]?.tMagnitude,
                  tScore: current[0]?.tScore,
                },
              }
            }, [])
        }
      }
      return result
    } catch (error) {
      console.log('error', item)
    }
  }

  /*= =======================================================================
 Get List
======================================================================== */
  const reloadList = async () => {
    setLoading(true)
    const newList = await getListTags()
    if (Array.isArray(newList)) {
      setList(newList)
      newList.forEach(async (item) => {
        await handleFeelings(item).then(response => {
          if (typeof response === 'object' && response !== null && !Array.isArray(response)) {
            Object.assign(newList[newList.findIndex(el => el._id === response?._id)], response)
            setUpdate(true)
          }
        })
      })
      setLoading(false)
    }
  }

  /*= =======================================================================
 Post List
======================================================================== */
  const handleCreateList = async event => {
    event.preventDefault()
    setLoading(true)
    try {
      const response = await createList(creatList)
      if (response) {
        await reloadList()
        setLoading(false)
        setOpenAddToList(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setUpdate(false)
  }, [update])

  useEffect(() => {
    reloadList()
  }, [])

  const filteredList = filterArray(list, 'nombre', searchList)

  return (
    <>
      <YoutubePage
        setOpenAddToList={setOpenAddToList}
        handleCreateList={handleCreateList}
        handleSearchList={handleSearchList}
        handleSelectList={handleSelectList}
        getFeelings={handleFeelings}
        loading={loading}
        openAddToList={openAddToList}
        searchList={searchList}
        onChange={onChange}
        creatList={creatList}
        list={filteredList}
      />
    </>
  )
}

export default YoutubeContainer
